import { type TenantInfo } from '../models/TenantInfo'
import { Amplify } from 'aws-amplify'
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito'
import { type AuthConfig } from '@aws-amplify/core'

// https://github.com/aws-amplify/amplify-js/issues/13707

export function configureAmplify (tenantInfo: TenantInfo): void {
  const authConfig: AuthConfig = {
    Cognito: {
      userPoolClientId: tenantInfo.COGNITO_APP_CLIENT_ID,
      userPoolId: tenantInfo.COGNITO_USERPOOL_ID,
      loginWith: {
        oauth: {
          domain: tenantInfo.COGNITO_DOMAIN,
          scopes: ['email', 'aws.cognito.signin.user.admin', 'openid'],
          redirectSignIn: [`${window.location.origin}/login`],
          redirectSignOut: [`${window.location.origin}/logout`],
          responseType: 'token'
        }
      }
    }
  }

  Amplify.configure({
    Auth: authConfig
  })
  cognitoUserPoolsTokenProvider.authTokenStore.setAuthConfig(authConfig)
  console.log('amplify configure')
}
